<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 16C27 22.0751 22.0751 27 16 27M27 16C27 9.92487 22.0751 5 16 5M27 16H5M16 27C9.92487 27 5 22.0751 5 16M16 27C13.1755 24.0342 11.6 20.0956 11.6 16C11.6 11.9044 13.1755 7.96577 16 5M16 27C18.8245 24.0342 20.4 20.0956 20.4 16C20.4 11.9044 18.8245 7.96577 16 5M5 16C5 9.92487 9.92487 5 16 5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
